<template>
	<div class="full-width pa-4">
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-form ref="form">
			<v-layout>
				<v-flex xs12 sm12 md4 lg3>
					<v-select
						:items="mapOptions"
						v-model="selectedOption"
						label="Choose field to map"
						solo
						item-text="name"
						item-value="value"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="pos-rel">
					<label for="files">Upload a CSV formatted file: </label>
					<input
						ref="inputUpload"
						type="file"
						@change="onFileChange"
						accept=".csv"
						required
						class="input"
					/>
					<v-icon class="cancel-icon" @click="clearInput">
						{{ "cancel" }}
					</v-icon>
				</v-flex>
				<v-flex>
					<v-btn
						depressed
						color="primary"
						class="upload-btn"
						@click="uploadFile()"
						:disabled="!isOptionSelected"
					>
						Upload
					</v-btn>
				</v-flex>
			</v-layout>
			<div class="mt-3">
				<a
					target="_blank"
					:href="
						selectedOption === 'retailerName'
							? `${JEET_11_CDN_BASE_LINK}/sample-csv/map-retailer-name-sample.csv`
							: `${JEET_11_CDN_BASE_LINK}/sample-csv/map-tsm-number-sample.csv`
					"
					v-if="isOptionSelected"
					>Download sample file</a
				>
			</div>
		</v-form>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { SHOW_ALERT } from "@/store/action-types";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { JEET_11_CDN_BASE_LINK } from "@/store/config";

export default {
	name: "MapTSM",
	props: ["title", "themeInputColor"],
	data() {
		return {
			JEET_11_CDN_BASE_LINK,
			selectedOption: {},
			mapOptions: [
				{
					name: "Retailer Name",
					value: "retailerName"
				},
				{
					name: "TSM Phone number",
					value: "tsmNumber"
				},
				{
					name: "RBM Phone number",
					value: "rbmNumber"
				}
			],
			payload: []
		};
	},
	computed: {
		isOptionSelected() {
			return Object.keys(this.selectedOption).length > 0;
		},
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	},
	methods: {
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.createPayload(files[0]);
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.payload = [];
		},
		createPayload(file) {
			const reader = new FileReader();
			reader.onload = e => {
				const fileData = e.target.result;
				const fileRows = fileData.split("\n");
				//Remove Heading Row
				fileRows.shift();
				const payload = fileRows.reduce((payload, row) => {
					if (row.length) {
						const columns = row.split(",");
						const userId = columns[0];
						// \r is added by windows laptop
						const selectedEntry = columns[1]
							.split(".")[0]
							.split("\r")[0];
						if (
							this.selectedOption === "tsmNumber" &&
							selectedEntry.length > 7 &&
							userId
						)
							payload.push({
								userId,
								tsmNumber: +selectedEntry
							});
						else if (
							this.selectedOption === "rbmNumber" &&
							selectedEntry.length > 7 &&
							userId
						)
							payload.push({
								userId,
								rbmNumber: +selectedEntry
							});
						else if (userId && selectedEntry)
							payload.push({
								userId,
								retailerName: selectedEntry
							});
					}
					return payload;
				}, []);
				this.payload = payload;
			};
			reader.readAsText(file);
		},
		async uploadFile() {
			if (!this.payload.length) {
				this.showAlert("Please select a file to upload");
				return;
			}
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					retailerDetails: this.payload
				}
			};
			try {
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/updateRetailers`;
				const response = await ApiService.post(endpoint, payload);
				const { status, errMsg } = response.response;
				if (status.toLowerCase() === "success") {
					this.showAlert("Users Mapped Successfully");
					this.clearInput();
					this.selectedOption = {};
				} else {
					this.showAlert(errMsg);
				}
			} catch (e) {
				this.showAlert(e.message);
			}
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		}
	}
};
</script>
